import { Plugin } from 'hubspot-prosemirror/pm/state';
import { setTrSelectionPosition } from '../utils/documentUtils';
/**
 * TODO: move this into state for the FocusPlugin
 */ // eslint-disable-next-line no-restricted-syntax
let focusPluginState;
export const FocusPlugin = new Plugin({
  state: {
    init() {
      return {};
    },
    apply(tr, currentPluginState) {
      const meta = tr.getMeta(FocusPlugin);
      if (meta) {
        focusPluginState = meta;
        return meta;
      }
      return currentPluginState;
    }
  },
  view() {
    return {
      update: view => {
        if (focusPluginState && focusPluginState.focusView) {
          // only focus if it isn't currently focused
          window.requestAnimationFrame(() => {
            if (!focusPluginState.preserveSelection && view.hasFocus()) {
              return;
            }
            if (!view.hasFocus()) {
              view.focus();
            }
            const tr = focusPluginState.preserveSelection ? view.state.tr : setTrSelectionPosition(view.state.tr, focusPluginState.focusViewPos);
            view.dispatch(tr);
            focusPluginState = {};
          });
        }
      }
    };
  }
});